import { SpawnResponse } from 'types/api/spawn';
import { FetchResponse } from 'types/fetch';
import endpoints from '../endpoints';
import fetchReq from '../fetch';

type SpawnOptions = {
  accessToken: string;
  apikey: string;
};

export function fetchSpawnIdToken({
  accessToken,
  apikey
}: SpawnOptions): FetchResponse<SpawnResponse> {
  return fetchReq({
    body: {
      grant_type: 'token_spawn',
      response_mode: ['urn:ext:oauth:response-mode:body'],
      response_type: ['urn:ext:ietf:params:oauth:response-type:id_token'],
      subject_token: accessToken,
      subject_token_type_hint: 'access_token'
    },
    headers: {
      Authorization: `Basic ${window.btoa(apikey)}`
    },
    mark: 'spawn_id_token',
    method: 'POST',
    url: endpoints.token.spawn
  });
}

type SpawnXAuthCodeOptions = {
  accessToken: string;
  mark: string;
};

export function fetchSpawnXAuthCode({
  accessToken,
  mark
}: SpawnXAuthCodeOptions): FetchResponse<SpawnResponse> {
  return fetchReq({
    body: {
      grant_type: 'token_spawn',
      response_mode: ['urn:ext:oauth:response-mode:body'],
      response_type: ['code'],
      subject_token: accessToken
    },
    mark,
    method: 'POST',
    url: endpoints.token.spawn
  });
}

type SpawnRememberMeOptions = {
  accessToken: string;
};

export function fetchSpawnRememberMe({
  accessToken
}: SpawnRememberMeOptions): FetchResponse<SpawnResponse> {
  return fetchReq({
    body: {
      grant_type: 'token_spawn',
      options: {
        response_type: [
          { usage_context: 'THIRD_PARTY' },
          { usage_context: 'THIRD_PARTY' },
          { usage_context: 'THIRD_PARTY' }
        ]
      },
      response_mode: [
        'urn:ext:oauth:response-mode:cookie',
        'urn:ext:oauth:response-mode:cookie',
        'urn:ext:oauth:response-mode:cookie'
      ],
      response_type: [
        'urn:ext:ietf:params:oauth:response-type:remember_me',
        'urn:ext:ietf:params:oauth:response-type:remember_me_code',
        'urn:ext:ietf:params:oauth:response-type:remember_me_code_vdcp'
      ],
      subject_token: accessToken,
      subject_token_type_hint: 'access_token'
    },
    mark: 'spawn_remember_me',
    method: 'POST',
    url: endpoints.token.spawn
  });
}

type SpawnErmOptions = {
  accessToken: string;
};

export function fetchSpawnErm({ accessToken }: SpawnErmOptions): FetchResponse<SpawnResponse> {
  return fetchReq({
    body: {
      grant_type: 'token_spawn',
      options: { response_type: [{ usage_context: 'THIRD_PARTY' }] },
      response_mode: ['urn:ext:oauth:response-mode:cookie', 'urn:ext:oauth:response-mode:body'],
      response_type: ['urn:ext:ietf:params:oauth:response-type:activity_ref'],
      subject_token: accessToken
    },
    mark: 'spawn_erm',
    method: 'POST',
    url: endpoints.token.spawn
  });
}

type SpawnSsiOptions = {
  accessToken: string;
};

export function fetchSpawnSsi({ accessToken }: SpawnSsiOptions): FetchResponse<SpawnResponse> {
  return fetchReq({
    body: {
      grant_type: 'token_spawn',
      options: { response_type: [{ usage_context: 'THIRD_PARTY' }] },
      response_mode: ['urn:ext:oauth:response-mode:cookie'],
      response_type: ['urn:ext:ietf:params:oauth:response-type:secured_id_token'],
      subject_token: accessToken
    },
    mark: 'spawn_ssi',
    method: 'POST',
    url: endpoints.token.spawn
  });
}
